<script>
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import IconCart from "@js/components/Icons/IconCart.vue";
import {Link} from "@inertiajs/vue3";
import IconBag from "@js/components/Icons/IconBag.vue";

export default {
    name: "CatalogButton",
    components: {IconBag, IconCart, Link},
    props: {
        isBlurry: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hovered: false,
        }
    },
    setup() {
        const callbackStore = useCallbackFormsStore()

        return {callbackStore}
    }
}
</script>

<template>
    <Link :href="route('catalog')"
          @mouseover="hovered = true"
          @mouseout="hovered = false"
          :class="{
         'backdrop-blur-xl bg-white/5 hover:bg-indigo-600': isBlurry,
         'bg-indigo-600 hover:bg-transparent': !isBlurry,
         'text-white': !dark,
         'text-indigo-600': dark,
    }"
          class="inline-flex justify-center items-center hover:text-white border-2 border-indigo-600  font-medium rounded-full text-sm px-5 py-2.5 focus:outline-none transition">
        <IconBag class="w-5 h-5 me-3"/>
        <span class="text-base">
            Перейти в каталог
        </span>
    </Link>
</template>

<style scoped lang="scss">

</style>
